import { anchor } from './setting-anchors.types';

import type { SettingAnchor } from './setting-anchors.types';

/**
 * The Widget Design Studio's Global-settings CARDS — the two that render inside
 * `GlobalSettingsPane` (branding, ADR-0770's approved embed origins) and the
 * anonymous-access card on the welcome pane. A sibling map like the six the
 * registry already spreads, hoisted when the third card pushed
 * `setting-anchors.ts` past the ~300-line ceiling; the spread sits where the
 * block sat, so the palette order (`SETTING_KEYS`) is unchanged.
 */
export const STUDIO_GLOBAL_SETTING_ANCHORS = {
  // Widget Design Studio — Global settings step (T13)
  'widget-branding': anchor(
    'setting-widget-branding',
    '/widget',
    'workspacesettings.branding.heading',
    'surfaces',
    'edit',
    // Both cards render inside `GlobalSettingsPane`, which the Studio shows only
    // while its target is `panel` — so without this the jump opened the Studio on
    // Brand basics and landed on nothing at all, for four seconds, silently.
    { keywordsKey: 'settingSearch.widgetBranding', pane: 'panel' },
  ),
  // ADR-0770 — the approved-embed-origins editor. Same pane as the branding
  // card above (`GlobalSettingsPane` renders both, and the Studio shows that
  // pane only while its target is `panel`), so it takes the same `pane` hint —
  // without it a ⌘K jump opens the Studio on Brand basics and lands on nothing.
  'embed-origins': anchor(
    'setting-embed-origins',
    '/widget',
    'studio.embedOrigins.heading',
    'surfaces',
    'edit',
    { keywordsKey: 'settingSearch.embedOrigins', pane: 'panel' },
  ),
  'anonymous-access': anchor(
    'setting-anonymous-access',
    '/widget',
    'workspacesettings.anonymousAccess.heading',
    'surfaces',
    'edit',
    // The WELCOME pane, not the panel one: this card rides the surface a
    // signed-out visitor actually meets (`InspectorPanel.tsx`), which is not
    // where a reader would guess and is why the anchor pointed nowhere.
    { keywordsKey: 'settingSearch.anonymousAccess', pane: 'welcome' },
  ),
} as const satisfies Record<string, SettingAnchor>;
